import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { DirectionService } from '../../services/direction.service';
import { ProjectService } from '../../services/project.service';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, NgForm } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';


import { RadioButtonModule } from 'primeng/radiobutton';
import { InputIconModule } from 'primeng/inputicon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { StrategyService } from '../../services/strategy.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { SocketService } from '../../services/socket.service';
import { DropdownModule } from 'primeng/dropdown';
import { ToastrService } from 'ngx-toastr';
import { NotificationTypesEnum } from '../../interfaces';
import { NotificationService } from '../../services/notification.service';
import { Subject, takeUntil } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../../webviewer/webviewer.component';
import { environment } from '../../../environments/environment.development';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'projects-hub-file-auditor',
  standalone: true,
  imports: [
    NavTitlePipe,
    DropdownModule, RadioButtonModule, RouterModule, InputIconModule,
    TableModule, TooltipModule, CheckboxModule, InputTextareaModule,
    TagModule, FormsModule, InputTextModule,
    TranslateModule, ToastModule, ButtonModule, CommonModule,
    DialogModule, WebViewerComponent
  ],
  templateUrl: './projects-hub-file-auditor.component.html',
  styleUrl: './projects-hub-file-auditor.component.scss'
})


export class FileAuditorComponent implements OnInit, OnDestroy {
  domain = environment.domain;
  @ViewChild('assessmentForm') assessmentForm!: NgForm;
  @Input() projectId!: number;
  projects!: any[];

  dir!: 'rtl' | 'ltr';
  assessmentModal = false;
  selectedFile!: any;
  selectedStrategyId = 0;
  locale!: "ar" | "en";
  selectedStrategy = {} as Strategy;
  strategyOptions = [] as { name: string, strategyId: number }[];
  isFileViewer = false;

  constructor(
    private toastr: ToastrService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private projectService: ProjectService,
    private strategyService: StrategyService,
    private route: ActivatedRoute,
    private notificationService: NotificationService
  ) {

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  private unsubscribe$ = new Subject<void>();
  ngOnInit(): void {
    this.strategyService.RawStrategies$.pipe(takeUntil(this.unsubscribe$)).subscribe((strategies: Strategy[]) => {
      if (this.selectedStrategyId == 0) {
        let defultStrategy = strategies.find(x => x.is_default);
        this.selectedStrategyId = defultStrategy?.id || 0;
        this.selectedStrategy = defultStrategy as Strategy;
        this.strategyService.setStrategyIdfn(defultStrategy?.id || 0)
        this.strategyService.setSelectedPillarIdfn(0)
      }
      else {
        let Strategy = strategies.find(x => x.id == this.selectedStrategyId);
        this.selectedStrategy = Strategy as Strategy;
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
        this.strategyService.setSelectedPillarIdfn(0)
      }
      this.projectService.getProjectsFileAuditor(this.selectedStrategyId).subscribe((response: any) => {
        console.log('response', response);
        this.projects = response['data'].projects;
        this.filteredProjects = this.projects;
      })
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })

    this.directionService.direction$.pipe(takeUntil(this.unsubscribe$)).subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })
  }

  onRowExpand(event: TableRowExpandEvent) {

  }

  onRowCollapse(event: TableRowCollapseEvent) {

  }


  openAssessmentModal(file: any) {
    this.assessmentModal = true;
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }

  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }


  assessOutput() {
    this.projectService.reviewAuditFile(this.selectedStrategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      const parenProject = this.projects.find(x => x.id == this.selectedFile.project_id)

      if (parenProject) {
        const mappedFiles = parenProject.files.map((x: any) => x.id == this.selectedFile.id ? { ...this.selectedFile } : x)
        parenProject.files = mappedFiles
        this.projects = this.projects.map((x: any) => x.id == this.selectedFile.project_id ? { ...parenProject } : x)
        this.toastr.success(response['data']['message'])
      }
      this.socketService.connect();
      this.notificationService.pushAuditRequest(
        this.selectedStrategyId, {
        id: this.selectedFile.id,
        parentEntityId: parenProject?.id,
        subEntityId: this.selectedFile.subEntityId,
        type: NotificationTypesEnum.milestone_output_audit_response
      },
        this.locale
      )



    })
  }

  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };
  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };


  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }

  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.projectService.getProjectsFileAuditor(this.selectedStrategyId).subscribe((response: any) => {
        console.log('response', response);
        this.projects = response['data'].projects;
      })
    })
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }
  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
  downloadFile(file: any) {
    this.projectService.downloadMilestonOutput(this.selectedStrategyId, file.project_id, file.subEntityId, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }

  searchText = ''
  filteredProjects = [] as any[];
  filterProjects() {
    if (!this.searchText || !this.searchText.trim()) {
      // If search is empty, show all non-deleted projects
      this.filteredProjects = this.projects;
    } else {
      const searchLower = this.searchText.trim().toLowerCase();
      this.filteredProjects = this.projects.filter((x: any) => {
        return x.name?.toLowerCase().includes(searchLower)
      }
      );
    }
  }



}